import React from 'react'
import styled from '@emotion/styled'
import { Input } from 'antd'
import { FieldGroup, FieldLabel, FieldHint } from './styles'
import { TOKEN_STORAGE_HINT } from './copy'

interface PatFieldProps {
  id: string
  invalid?: boolean
  value: string
  onChange: (value: string) => void
}

const PatField = ({ id, invalid, value, onChange }: PatFieldProps) => {
  // Plain antd Input when valid: the error styling is an override that only
  // bites under .ant-input-status-error, so swapping keeps the valid field
  // free of a class that would never match.
  const Control = invalid ? ErrorInput : Input

  return (
    <FieldGroup>
      <FieldLabel htmlFor={id}>Personal access token</FieldLabel>
      <Control
        id={id}
        {...(invalid ? { status: 'error' as const } : {})}
        placeholder='Paste your token'
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <FieldHint>{TOKEN_STORAGE_HINT}</FieldHint>
    </FieldGroup>
  )
}

const ErrorInput = styled(Input)`
  &.ant-input-status-error {
    border-color: #a40000 !important;

    &:hover,
    &:focus {
      border-color: #a40000 !important;
    }
  }
`

export default PatField
